export default {
  border_radius_tiny: '2px',
  border_radius_xxs: '4px',
  border_radius_xs: '8px',
  border_radius_md: '16px',
  border_radius_lg: '24px',
  border_radius_xl: '32px',
  border_radius_circle: '50%',
} as const
